import { useState, useCallback } from 'react';
import { uploadImage } from './api';

const useUploadImage = () => {
  const [imageData, setImageData] = useState({});

  const handleUploadImage = useCallback(
    ({ file, type, onUploadProgress }) => {
      return new Promise((resolve, reject) => {
        uploadImage({ file, type, onUploadProgress })
          .then(res => {
            const { data } = res;
            resolve(res);
            setImageData(data);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    [setImageData]
  );

  return {
    imageData,
    setImageData,
    handleUploadImage
  };
};

export default useUploadImage;
